import axios from '@/utils/request.js'

export const getOrgStat = params => {
  return axios.post('/goods/gas/supervise/getOrgStat', params)
}

export const getNextOrgStat = params => {
  return axios.post('/goods/gas/supervise/getNextOrgStat', params)
}

export const getStreetStatInfo = params => {
  return axios.post('/goods/gas/supervise/getStreetStatInfo', params)
}
export const getStatisticsCheckList = stId => {
  return axios.post('/goods/gas/bGlmCheckresult/getStatisticsCheckList', {
    stId
  })
}

export const getCheckInfoList = params => {
  return axios.post('/goods/gas/bGlmCheckresult/getStatisticsCheckInfoList', params)
}

export const getRegionMess = (regionId) => { // 查询区域信息
  return axios.get(`/goods/gas/bGlmCheckresult/getRegionMess/${regionId}`)
}
